import { useTranslation } from 'react-i18next';

import { Flex } from 'components';

import { SceneStatusFilterEnum, SceneStatusFilterAll } from './MatchView';
import MatchViewFilterButton from './MatchViewFilterButton';

import { SceneWithProgress } from '../../ScenesProgressProvider';

import { SceneStatusEnum } from 'graphql/types';

export interface MatchViewProps {
  selectedFilter: SceneStatusFilterEnum;
  scenes: SceneWithProgress[];
  onFilter: (status: SceneStatusFilterEnum) => void;
}

const MatchViewFilter = ({
  selectedFilter,
  scenes,
  onFilter,
}: MatchViewProps) => {
  const { t } = useTranslation();

  const isTraining = !!scenes.find(
    (scene) => (scene.statuses || []).indexOf(SceneStatusEnum.TRAINING) > -1,
  );

  const isTournament = !!scenes.find(
    (scene) => (scene.statuses || []).indexOf(SceneStatusEnum.TOURNAMENT) > -1,
  );
  const isUnfinished = !!scenes.find(
    (scene) => (scene.statuses || []).indexOf(SceneStatusEnum.UNFINISHED) > -1,
  );

  const filters = [
    isTournament && (
      <MatchViewFilterButton
        key="tournament"
        active={SceneStatusEnum.TOURNAMENT === selectedFilter}
        isWithIcon
        labelKey={SceneStatusEnum.TOURNAMENT}
        onClick={() => onFilter(SceneStatusEnum.TOURNAMENT)}
      />
    ),
    isTraining && (
      <MatchViewFilterButton
        key="training"
        active={SceneStatusEnum.TRAINING === selectedFilter}
        isWithIcon
        labelKey={SceneStatusEnum.TRAINING}
        onClick={() => onFilter(SceneStatusEnum.TRAINING)}
      />
    ),
    isUnfinished && (
      <MatchViewFilterButton
        key="unfinished"
        active={SceneStatusEnum.UNFINISHED === selectedFilter}
        isWithIcon
        labelKey={SceneStatusEnum.UNFINISHED}
        onClick={() => onFilter(SceneStatusEnum.UNFINISHED)}
      />
    ),
  ].filter((f) => !!f);

  return !filters.length ? null : (
    <Flex css={{ lineHeight: '1.75em', alignItems: 'center' }}>
      <div>{t('matchView.filter', 'Filtr')}:</div>
      <MatchViewFilterButton
        active={SceneStatusFilterAll.ALL === selectedFilter}
        labelKey={SceneStatusFilterAll.ALL}
        onClick={() => onFilter(SceneStatusFilterAll.ALL)}
      />
      {filters}
    </Flex>
  );
};

export default MatchViewFilter;
